<script>
export default {
  name: "EffContractTeacherRemarkPopup",

  props: {
    title: {
      type: String,
      default: "Замечание к показателю"
    },

    content: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      menu: false,
    }
  }
}
</script>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="deep-orange"
        dark
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon
          size="20"
        >
          fa-comment
        </v-icon>
      </v-btn>
    </template>

    <v-card
      min-width="400px"
    >
      <v-card-title v-text="title"/>
      <v-card-text v-html="content"/>
    </v-card>
  </v-menu>
</template>

<style scoped>

</style>